<app-view #view [code]="'contacts.edit'" [model]="contact" (onEvent)="onEvent($event)"></app-view>